module.exports = __webpack_public_path__ + "img/p-female-dgrey.fea1d1ee.svg";